// Type definitions for player stats and skill levels
import { Video } from './video';
export interface PlayerStats {
  serves: number;
  spikes: number;
  blocks: number;
  digs: number;
  assists: number;
}

export interface PlayerSkillLevels {
  serving: number;
  spiking: number;
  blocking: number;
  passing: number;
  setting: number;
}

export interface PlayerEditData {
  position: string;
  jersey_number: string;
  hometown: string;
  height: string;
  grad_year: string;
  dominant_hand: string;
}

// Common volleyball positions
export const volleyballPositions = [
  'Outside Hitter',
  'Middle Blocker',
  'Setter',
  'Opposite Hitter',
  'Libero',
  'Defensive Specialist'
];

// Player interface that matches database structure
export interface Player {
  id?: string;
  profile_id: string;
  team_id?: string | null;
  position?: string | null;
  jersey_number?: number | null;
  height?: string | null;
  hometown?: string | null;
  grad_year?: number | null;
  dominant_hand?: string | null;
  profile_picture_url?: string | null;
  video_urls?: Video[] | string[];
  stats?: PlayerStats | string;
  skill_levels?: PlayerSkillLevels | string;
  games_played?: number | null;
  join_date?: string | null;
  created_at?: string | null;
  profile?: {
    id: string;
    first_name: string;
    last_name: string;
    email: string;
    is_verified?: boolean;
  };
  teams?: {
    id: string;
    name: string;
    clubs?: {
      id: string;
      name: string;
      organizations?: {
        id: string;
        name: string;
      };
    };
  };
}

// Utility functions to safely parse player data
export const parsePlayerStats = (stats: PlayerStats | string | null | undefined): PlayerStats => {
  if (typeof stats === 'string') {
    try {
      return JSON.parse(stats);
    } catch {
      return { serves: 0, spikes: 0, blocks: 0, digs: 0, assists: 0 };
    }
  }
  return stats || { serves: 0, spikes: 0, blocks: 0, digs: 0, assists: 0 };
};

export const parsePlayerSkillLevels = (skillLevels: PlayerSkillLevels | string | null | undefined): PlayerSkillLevels => {
  if (typeof skillLevels === 'string') {
    try {
      return JSON.parse(skillLevels);
    } catch {
      return { serving: 50, spiking: 50, blocking: 50, passing: 50, setting: 50 };
    }
  }
  return skillLevels || { serving: 50, spiking: 50, blocking: 50, passing: 50, setting: 50 };
};